import React from 'react';
const SizeContext = /*#__PURE__*/React.createContext('normal');
export default SizeContext;